module.exports = __webpack_public_path__ + "next-logo-horizontal.png";